import React, { useState } from "react";
import { Link, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function LoginPage() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    async function onSubmit(e) {
        e.preventDefault();
        setError("");
        setSubmitting(true);
        const res = await login(email, password);
        setSubmitting(false);
        if (res.ok) {
            const to = searchParams.get("next") || location.state?.from || "/dashboard";
            navigate(to);
        } else setError(res.error);
    }

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
            <div className="w-full max-w-md">
                <div className="label-eyebrow mb-4">/ Welcome back</div>
                <h1 className="font-serif text-4xl mb-8">Enter the <span className="gold-text italic">Butler Room</span></h1>
                <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
                    <div>
                        <label className="text-xs uppercase tracking-widest text-slate-400">Email</label>
                        <input
                            data-testid="login-email"
                            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                            className="mt-2 w-full bg-slate-900 border border-white/10 rounded-sm px-4 py-3 focus:outline-none focus:border-gold"
                        />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-widest text-slate-400">Password</label>
                        <input
                            data-testid="login-password"
                            type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                            className="mt-2 w-full bg-slate-900 border border-white/10 rounded-sm px-4 py-3 focus:outline-none focus:border-gold"
                        />
                    </div>
                    {error && <div data-testid="login-error" className="text-sm text-red-400">{error}</div>}
                    <button data-testid="login-submit" disabled={submitting} className="btn-gold w-full disabled:opacity-50">
                        {submitting ? "Signing in…" : "Sign in"}
                    </button>
                    <div className="text-center">
                        <Link to="/forgot-password" data-testid="forgot-link" className="text-sm text-slate-400 hover:text-gold">
                            Forgot your password?
                        </Link>
                    </div>
                    <div className="text-sm text-slate-400 text-center">
                        New here? <Link to="/register" className="gold-text hover:underline">Create an account</Link>
                    </div>
                </form>
            </div>
        </div>
    );
}
